import React from 'react'
import ReactDOM from 'react-dom'
import { App as AntApp, ConfigProvider } from 'antd'
import App from 'app'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'theme/reset.scss'
import reportWebVitals from './reportWebVitals'


ReactDOM.render(
  <ConfigProvider
    theme={{
      token: {
        colorPrimary: '#df7467',
        colorInfo: '#df7467',
        fontFamily: 'Source Sans Pro',
      },
    }}
  >
    <AntApp>
      <React.StrictMode>
        <App />
      </React.StrictMode>,
    </AntApp>
  </ConfigProvider>,

  document.getElementById('root'),
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
